<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="mb-0">Slides</h6>
      <span class="fs-12 text-muted">{{ slides.length }} slide{{ slides.length === 1 ? "" : "s" }}</span>
    </div>
    <div v-if="loading" class="py-4 text-center">
      <wtr-loader variant="primary" addText></wtr-loader>
    </div>
    <draggable
      v-else-if="localSlides.length"
      v-model="localSlides"
      class="presentation-slide-grid"
      :disabled="disabled"
      @end="handleDragEnd"
    >
      <div
        v-for="(slide, index) in localSlides"
        :key="slide.id"
        class="presentation-slide-tile"
      >
<!--         
        <button
          type="button"
          class="presentation-slide-image-button"
          title="View slide"
          @click.stop.prevent="openSlidePreview(slide, index)"
        > -->
          <wtr-img
            :src="slide.thumbnailPath || slide.path"
            :resourceId="slide.resourceId"
            :containerName="slide.containerName"
            :altImage="$icons.NO_THUMBNAIL_FOUND"
            imgClass="presentation-slide-image"
            disableLazy
          ></wtr-img>
        <!-- </button> -->
         <div
          class="presentation-slide-name"
          :title="getDisplaySlideName(index)"
        >
          {{ getDisplaySlideName(index) }}
        </div>
        <button
          type="button"
          class="presentation-slide-delete"
          title="Delete"
          :disabled="disabled"
          @click.stop.prevent="$emit('delete-slide', slide)"
        >
          <img
            class="presentation-slide-delete-icon"
            :src="require('@/assets//icons-new/Icons_Delete.svg')"
            alt="Delete"
          />
        </button>
      </div>
    </draggable>
    <div v-else class="text-muted fs-13 py-4 text-center">
      No slides uploaded
    </div>
    <b-modal
      v-model="showSlidePreview"
      :title="selectedSlideTitle"
      size="xl"
      centered
      hide-footer
      body-class="presentation-slide-preview-body"
      @hidden="resetSlidePreview"
    >
      <div class="presentation-slide-preview">
        <wtr-img
          v-if="selectedSlide"
          :src="selectedSlide.path || selectedSlide.thumbnailPath"
          :resourceId="selectedSlide.resourceId"
          :containerName="selectedSlide.containerName"
          :altImage="$icons.NO_THUMBNAIL_FOUND"
          imgClass="presentation-slide-preview-image"
          disableLazy
        ></wtr-img>
      </div>
    </b-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "presentation-slide-grid",
  components: {
    draggable,
  },
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSlides: [],
      selectedSlide: null,
      selectedSlideTitle: "",
      showSlidePreview: false,
    };
  },
  watch: {
    slides: {
      immediate: true,
      handler(slides) {
        this.localSlides = slides ? slides.slice() : [];
      },
    },
  },
  methods: {
    getDisplaySlideName(index) {
      return `Slide_${index + 1}.jpg`;
    },
    handleDragEnd(event) {
      if (!event || event.oldIndex === event.newIndex) return;
      this.$emit("reorder", this.localSlides.slice());
    },
    openSlidePreview(slide, index) {
      if (!slide || (!slide.path && !slide.thumbnailPath)) return;
      this.selectedSlide = slide;
      this.selectedSlideTitle = this.getDisplaySlideName(index);
      this.showSlidePreview = true;
    },
    resetSlidePreview() {
      this.selectedSlide = null;
      this.selectedSlideTitle = "";
    },
  },
};
</script>

<style scoped lang="scss">
.presentation-slide-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
}

.presentation-slide-tile {
  position: relative;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  cursor: grab;
}

.presentation-slide-delete {
  position: relative;
  top: 6px;
  right: 6px;
  z-index: 1;
  width: 12px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  line-height: 1;
  cursor: pointer;
  float: right;
}

.presentation-slide-delete:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.presentation-slide-delete-icon {
  width: 16px;
  height: 16px;
}

.presentation-slide-tile:active {
  cursor: grabbing;
}

.presentation-slide-image-button {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.sortable-ghost {
  opacity: 0.5;
}

.presentation-slide-tile ::v-deep .presentation-slide-image {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: contain;
  background: #f8f9fa;
}

.presentation-slide-name {
  padding: 6px 8px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  float:left
}

.presentation-slide-preview {
  overflow: auto;
  max-height: calc(100vh - 190px);
}

.presentation-slide-preview ::v-deep .presentation-slide-preview-image {
  display: block;
  width: auto;
  height: auto;
  max-width: none;
  max-height: none;
  margin: 0 auto;
}
</style>
